import React from 'react';
import { inject, observer } from 'mobx-react';
import JsxRenderer from '../JsxRenderer';
import NotFound from '../common/NotFound';
import NewsStore, { INewsItem, NewsParams } from '../../stores/NewsStore';
import { Button, Container, Grid, GridColumn, Separator, Spinner, TGridColumnWidth, Text } from 'telia-front-react';
import { NewsItem } from './NewsItem';

interface NewsProps {
  params?: NewsParams;
  showExcerpt?: boolean;
  showButton?: boolean;
  buttonText?: string;
  rootPath?: string;
  title?: string;
  linkText: string;
  gridClasses: TGridColumnWidth[];
  newsStore?: NewsStore;
}

interface NewsState {
  count: number;
}

@observer
class News extends React.Component<NewsProps, NewsState> {
  public static defaultProps: Partial<NewsProps> = {
    params: {
      offset: 0,
      perPage: 9
    },
    rootPath: '/uudised/',
    showExcerpt: true,
    showButton: true,
    buttonText: 'Read more',
    title: null,
    gridClasses: ['xs-12', 'sm-6', 'md-4']
  };

  public constructor(props: NewsProps) {
    super(props);
    this.state = { count: props.params.perPage };
  }

  public componentDidMount() {
    this.props.newsStore.subscribe(this.props.params);
  }

  public componentWillUnmount() {
    this.props.newsStore.unsubscribe();
  }

  private fetchMore = () => {
    const count = this.state.count + this.props.params.perPage;
    this.props.newsStore.fetchMore(count);
    this.setState({ count });
  };

  private renderNewsItem = (newsItem: INewsItem) => {
    const { gridClasses, linkText, showExcerpt, rootPath } = this.props;
    return (
      <GridColumn key={newsItem.id} width={gridClasses} border={['bottom-xs']}>
        <NewsItem
          title={newsItem.title}
          date={newsItem.date}
          anchor={{
            url: rootPath + newsItem.slug,
            text: linkText
          }}
          headingLevel={2}
        >
          {showExcerpt ? <JsxRenderer jsx={newsItem.excerpt} showErrorNotice={true} /> : null}
        </NewsItem>
      </GridColumn>
    );
  };

  private renderButton(newsStore: NewsStore, buttonText: string, showButton: boolean) {
    if (newsStore.isFetching()) {
      return <Spinner />;
    }
    if (newsStore.allFetched() && newsStore.allShown(this.state.count)) {
      return null;
    }
    return showButton ? <Button text={buttonText} onClick={this.fetchMore} /> : null;
  }

  public render() {
    const { newsStore, buttonText, title, showButton } = this.props;
    if (newsStore.notFound()) {
      return <NotFound />;
    }
    const newsList = newsStore.newsItems(this.state.count);
    return (
      <Container>
        <Text>
          {title ? <h1>{title}</h1> : null}
          <Separator spacing="medium" color="invisible" />
          <Grid equalHeight verticalGutter="medium" borderColor="light" element="ul">
            {newsList.map(this.renderNewsItem)}
          </Grid>
          <Separator spacing="large" color="invisible" />
          <div className="text-center">{this.renderButton(newsStore, buttonText, showButton)}</div>
        </Text>
      </Container>
    );
  }
}

export default inject('newsStore')(News);
